import { render, staticRenderFns } from "./EditComplianceSources.vue?vue&type=template&id=097f064a&"
import script from "./EditComplianceSources.vue?vue&type=script&lang=js&"
export * from "./EditComplianceSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports